export const faqItems = [
  {
    id: 1,
    question: '喵趣漫画网上的漫画真的全部免费吗？',
    answer: '是的，喵趣漫画网所有韩漫、日漫、国漫均提供免费全集阅读，无需充值会员即可畅享下拉式在线阅读体验。我们通过广告合作维持运营，始终承诺核心阅读功能永久免费。',
  },
  {
    id: 2,
    question: '什么是下拉式阅读？如何使用？',
    answer: '下拉式阅读是一种针对移动端优化的漫画浏览方式，您只需在页面中向下滑动即可连续阅读下一话内容，无需频繁点击翻页按钮。进入任意漫画详情页后自动启用，长条漫画尤其适合这种沉浸式阅读体验。',
  },
  {
    id: 3,
    question: '网站上的漫画多久更新一次？',
    answer: '我们与多家汉化组和官方平台保持合作，热门连载漫画通常每周更新1-2话。国漫同步官方更新节奏，韩漫和日漫在汉化完成后24小时内上线。您可以在「更新快讯」模块查看最新上架记录。',
  },
  {
    id: 4,
    question: '支持在手机和平板上阅读吗？',
    answer: '喵趣漫画网采用响应式设计，完美适配手机、平板和电脑浏览器。移动端阅读时自动启用下拉式模式，横屏阅读也有优化，无论iOS还是Android设备都能流畅阅读。',
  },
  {
    id: 5,
    question: '如何投稿或推荐漫画给平台？',
    answer: '欢迎通过页面底部的联系投稿入口向我们推荐优质漫画或提交汉化作品。请提供漫画名称、来源和简要介绍，我们的内容团队会在3个工作日内审核回复。',
  },
];

export const carouselItems = [
  {
    id: 1,
    title: '韩漫精选 · 都市恋爱',
    subtitle: '首尔爱情故事，每一页都心动',
    category: '韩漫',
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20webtoon%20art%20style%2C%20soft%20pastel%20color%20palette%2C%20romantic%20couple%20in%20urban%20Seoul%20city%20background%2C%20cinematic%20lighting%20with%20cherry%20blossom%20petals%2C%20warm%20and%20dreamy%20atmosphere%2C%20clean%20webtoon%20illustration%20style%2C%20simple%20uncluttered%20composition&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '日漫经典 · 少年热血',
    subtitle: '燃动青春，永不褪色的经典',
    category: '日漫',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20shonen%20manga%20action%20scene%20illustration%2C%20dynamic%20posing%20with%20vibrant%20warm%20colors%2C%20speed%20lines%20effect%2C%20energetic%20young%20protagonist%2C%20anime%20manga%20style%20with%20dramatic%20composition%2C%20golden%20sunset%20lighting%2C%20clean%20simple%20background&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '国漫崛起 · 玄幻修仙',
    subtitle: '东方幻想，笔墨间的仙侠世界',
    category: '国漫',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20cultivation%20comic%20art%2C%20ink%20painting%20style%20with%20golden%20accents%2C%20floating%20mountains%20and%20ancient%20temples%2C%20ethereal%20glowing%20energy%2C%20traditional%20Chinese%20aesthetic%20with%20modern%20comic%20rendering%2C%20mystical%20atmosphere%2C%20warm%20golden%20and%20crimson%20tones&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '悬疑推理 · 烧脑佳作',
    subtitle: '层层反转，不看到最后猜不到结局',
    category: '日漫',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20manga%20noir%20illustration%2C%20detective%20character%20in%20dark%20alley%20at%20night%2C%20moody%20warm%20street%20lamp%20lighting%2C%20suspenseful%20atmosphere%20with%20shadows%2C%20minimalist%20comic%20style%2C%20golden%20amber%20and%20deep%20brown%20color%20palette&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '搞笑日常 · 解压必备',
    subtitle: '笑到停不下来，生活需要一点甜',
    category: '国漫',
    image: 'https://readdy.ai/api/search-image?query=Wholesome%20comedy%20slice%20of%20life%20comic%20illustration%2C%20chibi%20characters%20in%20cozy%20cafe%20setting%2C%20bright%20warm%20lighting%20with%20playful%20expressions%2C%20pastel%20color%20palette%20with%20sunlight%20streaming%20through%20windows%2C%20simple%20clean%20webtoon%20style&width=800&height=450&seq=carousel-05&orientation=landscape',
  },
  {
    id: 6,
    title: '奇幻异世界 · 史诗冒险',
    subtitle: '穿越次元，开启不可思议的旅程',
    category: '韩漫',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20isekai%20webtoon%20manhwa%20art%2C%20magical%20portal%20opening%20to%20another%20world%2C%20adventurous%20characters%20with%20flowing%20capes%2C%20warm%20golden%20magical%20glow%2C%20dreamy%20atmosphere%20with%20floating%20crystals%2C%20Korean%20webtoon%20illustration%20style%2C%20rich%20color%20palette&width=800&height=450&seq=carousel-06&orientation=landscape',
  },
];

export const cardItems = [
  {
    id: 1,
    title: '霸道总裁的契约新娘',
    category: '韩漫',
    tag: '恋爱',
    desc: '契约婚姻背后的秘密，当冰山总裁遇上倔强新娘，一场势均力敌的较量就此展开。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20art%2C%20elegant%20CEO%20male%20lead%20and%20beautiful%20female%20lead%20in%20luxury%20setting%2C%20soft%20romantic%20lighting%2C%20pastel%20color%20palette%2C%20dramatic%20composition%2C%20clean%20minimal%20background%2C%20webtoon%20art%20style&width=600&height=800&seq=card-01&orientation=portrait',
  },
  {
    id: 2,
    title: '剑道至尊',
    category: '国漫',
    tag: '热血',
    desc: '少年持剑入江湖，从默默无闻到剑道至尊，一路披荆斩棘，问鼎天下第一。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20cultivation%20comic%20cover%2C%20swordsman%20with%20flowing%20robes%20holding%20ancient%20sword%2C%20dramatic%20wind%20effect%2C%20golden%20sunset%20mountain%20background%2C%20ink%20wash%20painting%20aesthetic%2C%20warm%20amber%20tones&width=600&height=800&seq=card-02&orientation=portrait',
  },
  {
    id: 3,
    title: '重生之影后归来',
    category: '韩漫',
    tag: '逆袭',
    desc: '前世的背叛与不甘，今生的华丽逆袭。当影后重生回到十年前，一切都将改写。',
    image: 'https://readdy.ai/api/search-image?query=Rebirth%20revenge%20webtoon%20cover%2C%20glamorous%20female%20lead%20in%20stunning%20red%20dress%20at%203DX20awards%20ceremony%2C%20dramatic%20spotlight%20effect%2C%20luxurious%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20warm%20golden%20and%20crimson%20lighting&width=600&height=800&seq=card-03&orientation=portrait',
  },
  {
    id: 4,
    title: '美食猎人',
    category: '日漫',
    tag: '冒险',
    desc: '在这个美食即力量的世界，少年厨师踏上寻找传说中的终极食材之旅。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20food%20adventure%20manga%20cover%20art%2C%20young%20chef%20with%20cooking%20tools%20in%20fantasy%20world%2C%20delicious%20food%20with%20magical%20glow%2C%20warm%20cozy%20color%20palette%2C%20anime%20manga%20illustration%20style%2C%20clean%20simple%20background&width=600&height=800&seq=card-04&orientation=portrait',
  },
  {
    id: 5,
    title: '鬼医毒妃',
    category: '国漫',
    tag: '古风',
    desc: '现代女军医穿越成废柴嫡女，一手医术一手毒术，搅动朝堂风云，倾倒天下。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20style%20female%20doctor%20comic%20cover%2C%20elegant%20female%20lead%20in%20traditional%20hanfu%20holding%20medicine%20bottle%2C%20ancient%20palace%20background%20with%20soft%20lantern%20glow%2C%20warm%20golden%20and%20jade%20green%20tones%2C%20ink%20painting%20influence&width=600&height=800&seq=card-05&orientation=portrait',
  },
  {
    id: 6,
    title: '我的女友是九尾狐',
    category: '韩漫',
    tag: '奇幻',
    desc: '普通大学生的生活因一只九尾狐的闯入而彻底改变，跨物种的浪漫喜剧就此上演。',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20romance%20webtoon%20cover%20with%20nine-tailed%20fox%20spirit%20female%20lead%2C%20magical%20fox%20ears%20and%20tails%2C%20modern%20Seoul%20city%20night%20background%2C%20dreamy%20moonlight%20atmosphere%2C%20Korean%20webtoon%20style%2C%20soft%20pastel%20colors&width=600&height=800&seq=card-06&orientation=portrait',
  },
  {
    id: 7,
    title: '全职猎魔师',
    category: '日漫',
    tag: '战斗',
    desc: '恶魔肆虐的现代都市，少年猎魔师用鲜血与意志守护人类最后的防线。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20action%20manga%20cover%2C%20demon%20hunter%20with%20magical%20weapon%20in%20urban%20night%20setting%2C%20dramatic%20red%20and%20black%20color%20contrast%2C%20intense%20battle%20atmosphere%2C%20Japanese%20manga%20illustration%20style%2C%20dynamic%20composition&width=600&height=800&seq=card-07&orientation=portrait',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '喵趣独家采访 · 当红漫画作者畅谈创作心路',
    desc: '从灵感到成稿，揭秘韩漫人气作者的工作日常与创作背后的感人故事。',
    category: '作者专访',
    image: 'https://readdy.ai/api/search-image?query=Comic%20artist%20interview%20scene%2C%20professional%20digital%20drawing%20tablet%20workstation%20with%20webtoon%20illustrations%20on%20screen%2C%20cozy%20studio%20with%20warm%20lighting%2C%20creative%20atmosphere%2C%20minimalist%20modern%20workspace%2C%20soft%20natural%20light%20from%20window&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '国漫崛起之路 · 从模仿到创新的十年蜕变',
    desc: '回顾国漫产业从跟跑到领跑的历程，解析中国漫画如何找到属于自己的表达方式。',
    category: '行业观察',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comic%20exhibition%20hall%20with%20large%20display%20screens%20showing%20various%20manhua%20artworks%2C%20crowded%20anime%20convention%20atmosphere%2C%20colorful%20posters%20and%20banners%2C%20warm%20vibrant%20lighting%2C%20modern%20exhibition%20space&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '下拉式阅读革命 · 漫画消费方式正在被重塑',
    desc: '从翻页到下滑，移动互联网如何改变漫画创作与阅读的底层逻辑。',
    category: '趋势解读',
    image: 'https://readdy.ai/api/search-image?query=Modern%20mobile%20phone%20displaying%20vertical%20webtoon%20comic%20reading%20interface%2C%20hand%20holding%20smartphone%20with%20colorful%20comic%20panels%2C%20cozy%20reading%20environment%20with%20warm%20ambient%20light%2C%20clean%20minimalist%20tabletop%20setting&width=800&height=500&seq=media-03&orientation=landscape',
  },
];

export const commentItems = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20icon%2C%20chibi%20style%2C%20soft%20pastel%20pink%20hair%2C%20happy%20smiling%20expression%2C%20simple%20clean%20background%2C%20minimalist%20illustration&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '星空下的猫',
    date: '2026年7月25日',
    content: '喵趣真的是我每天必刷的漫画站！下拉式阅读太舒服了，上班摸鱼偷偷看也不用一直点翻页，韩漫更新速度也很快，最近追的几部都第一时间更新了！',
    comic: '《霸道总裁的契约新娘》',
    likes: 328,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Handsome%20anime%20boy%20avatar%20icon%2C%20cool%20expression%2C%20dark%20hair%2C%20simple%20minimalist%20style%2C%20clean%20warm%20background&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '剑指苍穹',
    date: '2026年7月23日',
    content: '国漫区的内容越来越丰富了！《剑道至尊》画风真的炸裂，每一格都能截图当壁纸。希望平台能引进更多优质的国漫作品，支持国产！',
    comic: '《剑道至尊》',
    likes: 256,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20female%20anime%20avatar%20icon%2C%20brown%20hair%2C%20reading%20books%2C%20gentle%20smile%2C%20warm%20cozy%20style%2C%20simple%20clean%20background&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '书香漫影',
    date: '2026年7月20日',
    content: '作为一个从纸质漫画时代过来的老读者，喵趣的下拉式阅读体验让我重新爱上了看漫画。日漫经典专区做得很用心，好多童年回忆都能在这里找到。',
    comic: '《全职猎魔师》',
    likes: 189,
  },
];

export const topicItems = [
  { id: 1, name: '韩漫推荐', heat: '9.8万', color: 'bg-primary-100 text-primary-700' },
  { id: 2, name: '日漫经典', heat: '8.5万', color: 'bg-accent-100 text-accent-700' },
  { id: 3, name: '国漫崛起', heat: '7.2万', color: 'bg-secondary-100 text-secondary-700' },
  { id: 4, name: '霸道总裁', heat: '6.8万', color: 'bg-primary-100/70 text-primary-700' },
  { id: 5, name: '玄幻修仙', heat: '6.3万', color: 'bg-accent-100/70 text-accent-700' },
  { id: 6, name: '重生逆袭', heat: '5.9万', color: 'bg-secondary-100/70 text-secondary-700' },
  { id: 7, name: '搞笑日常', heat: '5.4万', color: 'bg-primary-100/60 text-primary-700' },
  { id: 8, name: '悬疑推理', heat: '4.8万', color: 'bg-accent-100/60 text-accent-700' },
  { id: 9, name: '恋爱甜宠', heat: '4.5万', color: 'bg-secondary-100/60 text-secondary-700' },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    desc: '专为移动端优化的纵向阅读模式，下滑即可无缝衔接下一话，告别繁琐的翻页点击。',
  },
  {
    id: 2,
    icon: 'ri-global-line',
    title: '三漫汇聚',
    desc: '韩漫、日漫、国漫一站收录，热门连载与经典全集应有尽有，满足各类漫画爱好者的阅读需求。',
  },
  {
    id: 3,
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '热门连载最快24小时内同步汉化上线，让你追更永远快人一步，不再错过任何精彩。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '纯净阅读',
    desc: '清爽无弹窗广告干扰，沉浸式阅读体验。所有漫画均经过正版授权或合法汉化渠道获取。',
  },
];

export const updateItems = [
  {
    id: 1,
    date: '07-28',
    title: '《剑道至尊》第287话更新',
    desc: '剑意突破！林修终于领悟天阶剑法，与魔教教主激战至白热化。',
    tag: '国漫',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    id: 2,
    date: '07-28',
    title: '《霸道总裁的契约新娘》第94话',
    desc: '真相大白！原来当年的那场车祸另有隐情，女主的真实身份即将揭晓。',
    tag: '韩漫',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    id: 3,
    date: '07-27',
    title: '《鬼医毒妃》第156话更新',
    desc: '朝堂惊变！女主的毒术在关键时刻逆转全局，太子党羽纷纷倒戈。',
    tag: '国漫',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    id: 4,
    date: '07-27',
    title: '《重生之影后归来》第72话',
    desc: '颁奖典礼上的惊艳亮相，昔日陷害她的对手们终于尝到了苦果。',
    tag: '韩漫',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    id: 5,
    date: '07-26',
    title: '《美食猎人》第203话',
    desc: '传说中的终极食材「龙鳞菇」终于出现，各方势力闻风而动。',
    tag: '日漫',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    id: 6,
    date: '07-26',
    title: '《我的女友是九尾狐》第118话',
    desc: '九尾狐的身份被男主意外发现，两人关系迎来最大考验。',
    tag: '韩漫',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    id: 7,
    date: '07-25',
    title: '《全职猎魔师》第165话',
    desc: 'S级恶魔降临都市，猎魔师协会紧急集结，大战一触即发。',
    tag: '日漫',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    id: 8,
    date: '07-25',
    title: '《霸道总裁》特别篇上线',
    desc: '七夕特别篇甜蜜放送！总裁与女主的浪漫约会，满满的狗粮来袭。',
    tag: '韩漫',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    id: 9,
    date: '07-24',
    title: '新作《星海迷航》第1话首更',
    desc: '喵趣独家引进！科幻国漫新作《星海迷航》震撼上线，开启星际冒险。',
    tag: '国漫',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
];

export const rankingItems = [
  {
    id: 1,
    rank: 1,
    title: '霸道总裁的契约新娘',
    category: '韩漫 · 恋爱',
    heat: '本周热度 2,856万',
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20scene%2C%20handsome%20CEO%20male%20lead%20in%20luxury%20office%2C%20tender%20moment%20with%20female%20lead%2C%20warm%20golden%20sunset%20light%20through%20floor-to-ceiling%20windows%2C%20soft%20romantic%20atmosphere%2C%20clean%20webtoon%20style&width=400&height=280&seq=rank-01&orientation=landscape',
  },
  {
    id: 2,
    rank: 2,
    title: '剑道至尊',
    category: '国漫 · 热血',
    heat: '本周热度 2,341万',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20comic%20battle%20scene%2C%20swordsman%20in%20mid-air%20strike%20pose%2C%20dramatic%20golden%20energy%20effects%2C%20mountain%20peak%20background%20with%20clouds%2C%20epic%20atmosphere%2C%20warm%20amber%20lighting&width=400&height=280&seq=rank-02&orientation=landscape',
  },
  {
    id: 3,
    rank: 3,
    title: '重生之影后归来',
    category: '韩漫 · 逆袭',
    heat: '本周热度 1,987万',
    image: 'https://readdy.ai/api/search-image?query=Glamorous%20awards%20ceremony%20webtoon%20scene%2C%20stunning%20actress%20on%20red%20carpet%2C%20flashing%20cameras%20and%20spotlights%2C%20luxurious%20evening%20atmosphere%2C%20Korean%20webtoon%20style%2C%20warm%20golden%20and%20rose%20lighting&width=400&height=280&seq=rank-03&orientation=landscape',
  },
  {
    id: 4,
    rank: 4,
    title: '鬼医毒妃',
    category: '国漫 · 古风',
    heat: '本周热度 1,756万',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20comic%20scene%2C%20beautiful%20female%20doctor%20in%20traditional%20hanfu%2C%20elegant%20courtyard%20with%20blooming%20plum%20blossoms%2C%20warm%20lantern%20light%2C%20ink%20wash%20aesthetic%2C%20soft%20atmospheric%20composition&width=400&height=280&seq=rank-04&orientation=landscape',
  },
  {
    id: 5,
    rank: 5,
    title: '美食猎人',
    category: '日漫 · 冒险',
    heat: '本周热度 1,523万',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20food%20manga%20cooking%20scene%2C%20chef%20presenting%20magnificent%20dish%20with%20dramatic%20glowing%20effect%2C%20excited%20judges%20reaction%2C%20warm%20kitchen%20atmosphere%2C%20anime%20manga%20style%2C%20vibrant%20colors&width=400&height=280&seq=rank-05&orientation=landscape',
  },
];

export const indexItems = [
  {
    id: 1,
    title: '韩漫人气连载',
    desc: '最受欢迎的韩国漫画热门连载，每日更新不等待。',
    count: '48部',
    icon: 'ri-heart-line',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-600',
  },
  {
    id: 2,
    title: '日漫经典全集',
    desc: '经典日本漫画全集合集，一口气看到结局的畅快体验。',
    count: '156部',
    icon: 'ri-book-open-line',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-600',
  },
  {
    id: 3,
    title: '国漫精选推荐',
    desc: '优质国产漫画精选，从古风到科幻，发现国漫的无限可能。',
    count: '89部',
    icon: 'ri-china-railway-line',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-600',
  },
  {
    id: 4,
    title: '恋爱甜宠专区',
    desc: '甜到心坎里的恋爱漫画，少女心爆棚的必追清单。',
    count: '62部',
    icon: 'ri-heart-2-line',
    iconBg: 'bg-primary-100/70',
    iconColor: 'text-primary-600',
  },
  {
    id: 5,
    title: '热血战斗合集',
    desc: '燃到爆炸的战斗漫画，每一页都让你肾上腺素飙升。',
    count: '73部',
    icon: 'ri-fire-line',
    iconBg: 'bg-accent-100/70',
    iconColor: 'text-accent-600',
  },
  {
    id: 6,
    title: '奇幻异世界',
    desc: '穿越次元的奇幻之旅，在另一个世界展开史诗冒险。',
    count: '54部',
    icon: 'ri-magic-line',
    iconBg: 'bg-secondary-100/70',
    iconColor: 'text-secondary-600',
  },
  {
    id: 7,
    title: '悬疑推理馆',
    desc: '烧脑解谜的悬疑漫画，每一个细节都可能是关键线索。',
    count: '41部',
    icon: 'ri-search-eye-line',
    iconBg: 'bg-primary-100/60',
    iconColor: 'text-primary-600',
  },
];